import {InfiniteData, QueryClient, useInfiniteQuery, useQueryClient} from '@tanstack/react-query';
import IWBrokerClient from '../client/IWBrokerClient';
import {gatewayRealtimeQueryOptions} from './gatewayQueryUtils';

export type LogEntry = Record<string, any> & {timestamp: string};

export const logQueryKey = ['log'] as const;

const installedLogListeners = new WeakSet<QueryClient>();

function installLogListener(queryClient: QueryClient) {
    if (installedLogListeners.has(queryClient)) {
        return;
    }

    IWBrokerClient.socket.on('log', (logEntry: LogEntry) => {
        console.log('(logQuery) log entry', logEntry);
        queryClient.setQueryData<InfiniteData<LogEntry[], string | undefined>>(
            logQueryKey,
            (current: InfiniteData<LogEntry[], string | undefined> | undefined) => {
                if (!current?.pages.length) {
                    return current;
                }

                return {
                    pages: [[logEntry, ...current.pages[0]], ...current.pages.slice(1)],
                    pageParams: current.pageParams
                };
            }
        );
    });

    installedLogListeners.add(queryClient);
}

export function useLogQuery() {
    const queryClient = useQueryClient();
    installLogListener(queryClient);

    return useInfiniteQuery({
        queryKey: logQueryKey,
        queryFn: async ({pageParam: timestampBefore}) => {
            return IWBrokerClient.request('log', {timestampBefore}) as Promise<LogEntry[]>;
        },
        ...gatewayRealtimeQueryOptions,
        initialPageParam: undefined as string | undefined,
        getNextPageParam: (lastPage: LogEntry[]) => {
            return lastPage.length ? lastPage[lastPage.length - 1].timestamp : undefined;
        }
    });
}
